export { default } from "./TeacherSchoolProfile";
